<!--
  Aspedia VueJS Helper Component
  *=====
  Import Name:  nav-menu
  Name:         NavMenu
  Version:      1
  Date:         2018-03-13
  Author:       Christian Dale <cdale@aspedia.net>

  Description:      Generic navigation menu with dropdown support for i.e. Top Menu.
  Default Data:     N/A
  Component IMG:    N/A
  Ancestor:         N/A
  Available To:     N/A
  Builder Visible:  False
  Version History:
    1    2018-03-13    Christian Dale <cdale@aspedia.net>   Initial revision of the Tree Component.
  *=====
-->

<template>
  <div v-bind="navAttributes">
    <tree-view
      :model="model"
      :root-attributes="rootAttributes"
      :root-child-attributes="rootChildAttributes"
      :render-root-child-tag="true"
      :render-child-tag="true"
      root-tag="b-nav"
      root-child-tag="b-nav-item-dropdown"
      parent-tag="ul"
    >
      <nav-menu-item
        slot-scope="item"
        :item="item.item"
        :depth="item.depth"
      />
    </tree-view>
  </div>
</template>

<script>
import {TreeView} from 'components/helpers'
import NavMenuItem from './nav-menu-item'

export default {
  name: 'mega-menu',
  components: {
    NavMenuItem,
    'tree-view': TreeView,
    'nav-menu-item': NavMenuItem
  },
  props: {
    menuName: {
      type: String,
      default: ''
    },
    attributes: {
      type: Array,
      required: false,
      default: function() { return [] }
    },
    rootClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      model: []
    }
  },
  computed: {
    navAttributes: function() {
      return this.attributes
    },
    rootAttributes: function() {
      let classes = ['navbar-nav']
      if (this.rootClass !== '') {
        classes.push(this.rootClass)
      }

      return [
        {class: classes},
        {'data-dropdown-in': 'fadeIn'},
        {'data-dropdown-out': 'fadeOut'}
      ]
    }
  },
  mounted: function() {
    this.$aspediaLoader.getMenu(this.menuName,
      {
        cache: {
          max_age: 30 * 86400,
          timeout: 30 * 86400
        }
      })
      .then(response => {
        // JSON responses are automatically parsed.
        this.model = response
      })
      .catch((e) => {
        applogger.log('Could not retrieve menu:' + this.menuName)
      })
  },
  methods: {
    rootChildAttributes: function(item, model, depth, hasChildren) {
      return [{text: item.title}]
    }
  }
}
</script>

<style scoped>

</style>
